import React from 'react';
import {View, StyleSheet, Image} from 'react-native';
import Text from '@/components/basic/text';
import theme from '@/style';
import LazyImage from '@basicComponents/image';
import Price from '@/components/business/price';
import {WinnerResponse} from '../../dice-service';
import {useTranslation} from 'react-i18next';
const first = require('@components/assets/imgs/game/color/01.webp');
const second = require('@components/assets/imgs/game/color/02.webp');
const third = require('@components/assets/imgs/game/color/03.webp');
export interface WinnerItemProps {
  index?: number;
  page?: number;
}

const WinnerItem = ({
  index = 0,
  page = 1,
  userAvatar,
  userPhone,
  bonus,
}: WinnerItemProps & WinnerResponse) => {
  const {i18n} = useTranslation();
  const rank = React.useMemo(() => {
    return (page - 1) * 10 + index + 1;
  }, [index, page]);

  const rankIcon = React.useMemo(() => {
    if (rank <= 3) {
      const image = rank === 1 ? first : rank === 2 ? second : third;
      return <Image source={image} style={[styles.rankImage]} />;
    }
    return (
      <View style={[styles.rank, theme.flex.center]}>
        <Text color={'var(--T2-dark)'}>{rank}</Text>
      </View>
    );
  }, [rank]);

  return (
    <View
      style={[
        theme.padding.lrl,
        theme.padding.btml,
        index === 0 && theme.padding.topl,
      ]}>
      <View
        style={[
          theme.flex.row,
          theme.flex.between,
          theme.flex.centerByCol,
          styles.itemContainer,
        ]}>
        <View
          style={[theme.flex.row, theme.flex.centerByCol, theme.flex.flex1]}>
          {rankIcon}
          <LazyImage
            radius={12}
            imageUrl={userAvatar}
            width={24}
            height={24}
            occupancy="transparent"
          />
          <Text size="small" numberOfLines={1} style={[theme.margin.leftxxs]}>
            {userPhone}
          </Text>
        </View>
        <View style={[theme.flex.row, theme.flex.centerByCol]}>
          <Text fontFamily="fontDinBold">{i18n.t('label.won')} </Text>
          <Price
            price={bonus}
            textProps={{size: 'large', color: 'var(--T1)'}}
          />
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  itemContainer: {
    height: 40,
  },
  rank: {
    height: 20,
    borderRadius: 4,
    overflow: 'hidden',
    minWidth: 20,
    marginRight: 12,
    backgroundColor: 'var(--button)',
  },
  rankImage: {
    width: 20,
    height: 20,
    marginRight: 12,
  },
});

export default WinnerItem;
